import {Directive, ElementRef, HostListener, Input, OnDestroy, Renderer2} from '@angular/core';
import {fromEvent} from "rxjs";
import {debounceTime, throttleTime} from "rxjs/operators";

@Directive({
  selector: '[whiteTooltip]'
})
export class WhiteTooltipDirective implements OnDestroy{
  @Input('whiteTooltip') tooltipTitle: string;
  @Input('tooltip-pos') tooltipPos: string;
  tooltip: HTMLElement;
  offset = 10;
  delay = 200;
  closeTimer: number;
  private subscriber;
  constructor(private el: ElementRef, private renderer: Renderer2) {
    this.subscriber = fromEvent(window, 'pointermove').pipe(debounceTime(100)).subscribe((event:PointerEvent)=>{
      if (this.tooltip){
        if (event.target !== this.el.nativeElement && !this.el.nativeElement.contains(event.target)) {
          this.hide();
        }
      }

    })
  }

  @HostListener('pointerenter') onMouseEnter() {
    if (!this.tooltip && this.tooltipTitle) {this.show(); }
  }

  @HostListener('pointerleave') onMouseLeave() {
    if (this.tooltip && this.tooltipTitle) { this.hide(); }
  }

  @HostListener('click') onClick() {
    if (this.tooltip && this.tooltipTitle) { this.hide(); }
  }

  ngOnDestroy(): void {
    this.subscriber.unsubscribe();
  }

  isTooltipSilented(): boolean {
    return this.el.nativeElement.getAttribute('tooltip-silent') === 'true';
  }

  show(isPreventPosition?) {
    if (this.isTooltipSilented()) {
      return;
    }
    clearTimeout(this.closeTimer);
    this.create();
    if (!isPreventPosition){
      this.setPosition();
    }
    this.renderer.addClass(this.tooltip, 'ng-tooltip-show');
  }

  hide(time?) {
    clearTimeout(this.closeTimer);
    if (this.tooltip){
      this.renderer.removeClass(this.tooltip, 'ng-tooltip-show');
    }
    this.closeTimer = window.setTimeout(() => {
      if (this.tooltip){
        this.tooltip.remove();
      }
      this.tooltip = null;
    }, time || this.delay);
  }

  create() {
    let needTooltipToBeCreated = !this.tooltip;
    if (needTooltipToBeCreated) {
      this.tooltip = this.renderer.createElement('span');
    }

    this.renderer.setProperty(
      this.tooltip,
      'innerHTML',
      this.tooltipTitle
    );

    if (needTooltipToBeCreated) {
      this.renderer.appendChild(document.body, this.tooltip);
      this.renderer.addClass(this.tooltip, 'ng-white-tooltip');
      this.renderer.addClass(this.tooltip, `ng-tooltip-top`);


      (this.tooltipPos) ? this.renderer.addClass(this.tooltip, this.tooltipPos) : this.renderer.addClass(this.tooltip, 'default-pos');

      this.tooltip.addEventListener('mouseenter', () => {
        this.show(true);
      });
      this.tooltip.addEventListener('mouseleave', () => {
        this.hide();
      });
    }

    this.renderer.setStyle(this.tooltip, '-webkit-transition', `opacity ${this.delay}ms`);
    this.renderer.setStyle(this.tooltip, '-moz-transition', `opacity ${this.delay}ms`);
    this.renderer.setStyle(this.tooltip, '-o-transition', `opacity ${this.delay}ms`);
    this.renderer.setStyle(this.tooltip, 'transition', `opacity ${this.delay}ms`);
  }

  setPosition() {
    const hostPos = this.el.nativeElement.getBoundingClientRect();
    const tooltipPos = this.tooltip.getBoundingClientRect();

    let top, left;

    if (this.tooltipPos){
      switch (this.tooltipPos) {
        case 'bottom-center':
          top = hostPos.top + hostPos.height + this.offset + 20;
          left =  hostPos.left + (hostPos.width - tooltipPos.width) / 2;
          break;
        case 'top-right':
          top = hostPos.top + hostPos.height/2 - tooltipPos.height;
          left = hostPos.right + 10;
          break;
        case 'center-right':
          top = hostPos.top + hostPos.height/2 - tooltipPos.height/2;
          left = hostPos.right + 10;
          break;
        case 'center-left':
          top = hostPos.top + hostPos.height/2 - tooltipPos.height/2;
          left = hostPos.left - 10 - tooltipPos.width;
          break;
        default:
          top = hostPos.top - tooltipPos.height - this.offset;
          left = hostPos.left + (hostPos.width - tooltipPos.width) / 2;
          break;
      }
    }
    else {
      top = hostPos.top - tooltipPos.height - this.offset;
      left = hostPos.left + (hostPos.width - tooltipPos.width) / 2;
    }

    if (this.tooltipPos != 'center-right' && this.tooltipPos != 'center-left'){
      this.renderer.setStyle(this.tooltip, 'top', `${top-10}px`);
    }
    else{
      this.renderer.setStyle(this.tooltip, 'top', `${top}px`);
    }
    this.renderer.setStyle(this.tooltip, 'left', `${left}px`);
  }

}
